import React from 'react';
import { Button } from 'antd';
import type { TelegramUser } from '@wbstats/shared';

interface Props {
  botName: string;
  onAuth: (user: TelegramUser) => void;
}

export const MockTelegramLoginButton: React.FC<Props> = ({ onAuth }) => {
  const handleClick = () => {
    // Create a mock Telegram user object with hardcoded values
    const mockUser = {
      id: parseInt(process.env.MOCK_USER_TELEGRAM_ID || '123456'),
      is_bot: false,
      first_name: process.env.MOCK_USER_FIRST_NAME || 'First Name',
      username: process.env.MOCK_USER_USERNAME || 'username',
    } as TelegramUser;

    onAuth(mockUser);
  };

  return (
    <Button
      type="primary"
      onClick={handleClick}
      style={{
        backgroundColor: '#54a9eb',
        display: 'flex',
        alignItems: 'center',
        padding: '10px 20px',
        borderRadius: '8px',
      }}
    >
      <svg viewBox="0 0 24 24" width="24" height="24" fill="#fff" style={{ marginRight: 8 }}>
        <path d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm5.43 7.13l-1.81 8.53c-.14.64-.5.79-1.02.49l-2.82-2.08-1.36 1.31c-.15.15-.28.28-.57.28l.2-2.86 5.21-4.71c.23-.2-.05-.31-.35-.12l-6.43 4.05-2.77-.87c-.6-.19-.61-.6.13-.89l10.83-4.18c.5-.19.94.11.76 1.05z" />
      </svg>
      Войти с помощью Telegram (devmode)
    </Button>
  );
};
